import React from 'react';
import { Button } from 'reactstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_ResendInvite, gAPI_Group_By_Id } from '../../../../../../constants/APIs';
import { NotificationManager } from "../../../../../../components/common/react-notifications";

export default function ReinviteUserForm({
  id
}) {

  const handleReInvite = data => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Group_By_Id}/${getGroupID()}`,
    })
      .then(res => {
        AxiosAPI({
          method: 'put',
          url: `${postAPI_ResendInvite}/${data}/resend-invite`,
          data: {
            groupName: res.data.name
          },
        }).then(resnew => {
          navigator.clipboard.writeText(resnew.data.url);
          NotificationManager.success(
            "",
            "Invitation sent successfully and URL copied to clipboard.",
            3000,
            null,
            null,
            "success"
          );
        }
        );
      })
      .catch(err => console.error(err));
  };

  return (

    <Button
      color="primary"
      size="sm"
      onClick={() => handleReInvite(id)}
    >
      Resend
    </Button>

  );
}
